import firebase from 'firebase'

const state = {
  dialog: {
    show: false,
    message: '',
    contentNote: {}
  }
}

const getters = {
  dialogContentNoteStore: state => state.dialog
}

const actions = {

}

const mutations = {
  openDialogContentNote(state, contentNote) {
    state.dialog.show = true
    state.dialog.message = contentNote != null ? contentNote.text : ''
    state.dialog.contentNote = contentNote != null ? contentNote : {}
  },
  closeDialogContentNote(state) {
    state.dialog.show = false 
    state.dialog.message = '',
    state.dialog.contentNote = {}
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}